/**
 * Megamenú multirama — Gudslip (Figma 11971).
 * - Hover/focus con intención en los enlaces del nav con [data-mega-trigger]
 *   abre su panel [data-mega-panel="marca"]; se cierra al salir del header,
 *   con Esc o al abrir otro panel.
 * - Las cards de producto viven en <template data-mega-cards="marca"> (una sola
 *   fuente) y se montan al vuelo en el grid del panel y en el menú móvil.
 * - Hover en una categoría [data-mega-cat] → los destacados del panel se funden
 *   a 4 productos de esa colección (GET /collections/<handle>?sections=
 *   iurop-mega-cards, cacheado). Al reabrir el panel vuelven los bestsellers.
 * Va por data-*: data-mega-root, data-mega-trigger, data-mega-panel,
 * data-mega-grid, data-mega-cards, data-mega-mobile-cards, data-mega-cat,
 * data-mega-products-heading.
 */
(function () {
  'use strict';

  var OPEN_DELAY = 60;
  var CLOSE_DELAY = 200;
  var CAT_DELAY = 130; // intención de hover sobre una categoría
  var SWAP_MS = 170; // duración del fade-out (sincronizada con el CSS)
  var openTimer, closeTimer, catTimer;
  var catCache = {}; // handle -> html de cards (o '' si la colección no vale)
  var defaults = {}; // brand -> { html, heading } (bestsellers por defecto)
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function root() {
    return document.querySelector('[data-mega-root]');
  }

  function mountCards() {
    var r = root();
    if (!r) return;
    r.querySelectorAll('template[data-mega-cards]').forEach(function (tpl) {
      var brand = tpl.getAttribute('data-mega-cards');
      var grid = r.querySelector('[data-mega-grid="' + brand + '"]');
      if (grid && !grid.dataset.mounted) {
        grid.innerHTML = tpl.innerHTML;
        grid.dataset.mounted = '1';
        var panel = grid.closest('[data-mega-panel]');
        var heading = panel ? panel.querySelector('[data-mega-products-heading]') : null;
        defaults[brand] = {
          html: tpl.innerHTML,
          heading: heading ? heading.textContent : ''
        };
      }
      var mobile = document.querySelector('[data-mega-mobile-cards="' + brand + '"]');
      if (mobile && !mobile.dataset.mounted) {
        mobile.innerHTML = tpl.innerHTML;
        mobile.dataset.mounted = '1';
      }
    });
  }

  function closeAll() {
    var r = root();
    if (!r) return;
    r.querySelectorAll('[data-mega-panel]').forEach(function (p) {
      p.hidden = true;
      p.classList.remove('is-open');
    });
    document.querySelectorAll('[data-mega-trigger]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
    document.documentElement.removeAttribute('data-mega-open');
  }

  function openPanel(brand, trigger) {
    var r = root();
    if (!r) return;
    var panel = r.querySelector('[data-mega-panel="' + brand + '"]');
    if (!panel) return;
    closeAll();
    resetGrid(panel);
    panel.hidden = false;
    // reflow para que la transición de entrada (.is-open) dispare tras el unhide
    void panel.offsetWidth;
    panel.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.setAttribute('data-mega-open', 'true');
  }

  // ── Destacados por categoría (hover en [data-mega-cat]) ──────────────────

  // Cada apertura del panel arranca en los bestsellers por defecto
  function resetGrid(panel) {
    var brand = panel.getAttribute('data-mega-panel');
    var grid = panel.querySelector('[data-mega-grid]');
    var def = defaults[brand];
    if (!grid || !def) return;
    delete grid.dataset.pending;
    if (grid.dataset.current) {
      grid.innerHTML = def.html;
      delete grid.dataset.current;
    }
    var heading = panel.querySelector('[data-mega-products-heading]');
    if (heading && def.heading) heading.textContent = def.heading;
  }

  function fetchCat(url) {
    if (Object.prototype.hasOwnProperty.call(catCache, url)) {
      return Promise.resolve(catCache[url]);
    }
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return fetch(url + sep + 'sections=iurop-mega-cards')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (json) {
        var html = '';
        if (json && json['iurop-mega-cards']) {
          var box = document.createElement('div');
          box.innerHTML = json['iurop-mega-cards'];
          var payload = box.querySelector('[data-mega-cards-payload]');
          if (payload && payload.querySelector('.gudslip-mega__card')) {
            html = payload.innerHTML;
          }
        }
        catCache[url] = html;
        return html;
      })
      .catch(function () { return ''; });
  }

  function swapGrid(panel, handle, label) {
    var grid = panel.querySelector('[data-mega-grid]');
    if (!grid || grid.dataset.current === handle) return;
    fetchCat(handle).then(function (html) {
      if (!html) return; // colección vacía o error: se quedan las cards actuales
      // Si mientras cargaba el usuario pasó a otra categoría, no pisarla
      if (grid.dataset.pending !== handle) return;
      var heading = panel.querySelector('[data-mega-products-heading]');
      var apply = function () {
        grid.innerHTML = html;
        grid.dataset.current = handle;
        if (heading && label) heading.textContent = label;
      };
      if (reducedMotion) { apply(); return; }
      grid.classList.add('is-swapping');
      window.setTimeout(function () {
        apply();
        // reflow y fundido de vuelta
        void grid.offsetWidth;
        grid.classList.remove('is-swapping');
      }, SWAP_MS);
    });
  }

  function init() {
    var header = document.querySelector('[data-gudslip-header]');
    if (!header || header.dataset.megaReady) return;
    header.dataset.megaReady = '1';

    mountCards();

    header.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
      var brand = trigger.getAttribute('data-mega-trigger');

      trigger.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        window.clearTimeout(openTimer);
        openTimer = window.setTimeout(function () {
          openPanel(brand, trigger);
        }, OPEN_DELAY);
      });

      trigger.addEventListener('mouseleave', function () {
        window.clearTimeout(openTimer);
      });

      // Teclado: focus abre; el panel es alcanzable con Tab (está a continuación)
      trigger.addEventListener('focus', function () {
        openPanel(brand, trigger);
      });
    });

    // Hover con intención en una categoría → destacados de esa colección
    var megaRoot = root();
    if (megaRoot) {
      megaRoot.addEventListener('mouseover', function (e) {
        var link = e.target.closest('[data-mega-cat]');
        if (!link) return;
        var panel = link.closest('[data-mega-panel]');
        if (!panel) return;
        var grid = panel.querySelector('[data-mega-grid]');
        var handle = link.getAttribute('data-mega-cat');
        window.clearTimeout(catTimer);
        if (grid) grid.dataset.pending = handle;
        fetchCat(handle); // precarga ya (el swap espera la intención)
        catTimer = window.setTimeout(function () {
          swapGrid(panel, handle, link.textContent.trim());
        }, CAT_DELAY);
      });
      megaRoot.addEventListener('mouseout', function (e) {
        if (e.target.closest && e.target.closest('[data-mega-cat]')) {
          window.clearTimeout(catTimer);
        }
      });
    }

    // Mantener abierto mientras el ratón esté en el header o el panel
    header.addEventListener('mouseleave', function () {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(closeAll, CLOSE_DELAY);
    });
    header.addEventListener('mouseenter', function () {
      window.clearTimeout(closeTimer);
    });

    // Puente de hover ROBUSTO sobre el propio panel: entrar en el mega cancela el
    // cierre (aunque el mouseleave del header se haya disparado al cruzar el hueco
    // barra→panel); salir del mega reinicia el cierre. Cubre el "espacio invisible"
    // pedido: mientras el ratón esté sobre el panel, el megamenú NO se cierra.
    if (megaRoot) {
      megaRoot.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
      });
      megaRoot.addEventListener('mouseleave', function () {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(closeAll, CLOSE_DELAY);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    // Click fuera
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-gudslip-header]')) closeAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  /* ------------------------------------------------- pestañas menú móvil ---
   * Marcas a la izquierda: al pulsar una, se muestran SUS subcategorías en el
   * panel de la derecha (antes era un acordeón). Delegado, así aguanta re-render.
   */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-mm-tab]');
    if (!tab) return;
    var wrap = tab.closest('.gudslip-mega-mobile__tabs');
    if (!wrap) return;
    var brand = tab.getAttribute('data-mm-tab');

    wrap.querySelectorAll('[data-mm-tab]').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    wrap.querySelectorAll('[data-mm-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-mm-panel') === brand);
    });
  });
})();
